import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './UserManagement.module.scss';

type OwnProps = {
  option: string;
  inputValue: string;
  liProps: HTMLAttributes<HTMLLIElement> & { key: any };
  selectedOptions?: string[];
  testId?: string;
};

export const SelectOption = (props: OwnProps) => {
  const { selectedOptions, option, inputValue, liProps, testId } = props;
  const { key, ...restLiProps } = liProps;

  if (!option.toLowerCase().includes(inputValue.toLowerCase())) {
    return null;
  }

  const isSelected = !!selectedOptions?.find(
    (selectedOption) => selectedOption === option,
  );
  return (
    <li
      {...restLiProps}
      className={clsx(
        styles.rowContainer,
        styles.columnGap8,
        styles.selectItem,
        isSelected && styles.selectedItem,
      )}
    >
      <div data-test-id={testId}>{option}</div>
    </li>
  );
};
